import { useEffect, useState } from 'react';
import './AILoadingScreen.css';

interface AILoadingScreenProps {
  messages?: string[];
}

const defaultMessages = [
  'Warming up the engines',
  'Syncing intelligence',
  'Analyzing your context',
  'Preparing your experience',
];

const AILoadingScreen = ({ messages = defaultMessages }: AILoadingScreenProps) => {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const [displayedText, setDisplayedText] = useState('');

  // Typewriter effect
  useEffect(() => {
    const currentMessage = messages[currentMessageIndex];
    let charIndex = 0;
    setDisplayedText('');

    const typeInterval = setInterval(() => {
      if (charIndex < currentMessage.length) {
        setDisplayedText(currentMessage.slice(0, charIndex + 1));
        charIndex++;
      } else {
        clearInterval(typeInterval);
        setTimeout(() => {
          setCurrentMessageIndex((prev) => (prev + 1) % messages.length);
        }, 2000);
      }
    }, 45);

    return () => clearInterval(typeInterval);
  }, [currentMessageIndex, messages]);

  return (
    <div className="ai-loading-container">
      {/* Ambient background glow */}
      <div className="ai-ambient-glow" />

      <div className="ai-loading-content">
        {/* Brand */}
        <div className="ai-brand-wrapper">
          <div className="ai-brand">Gravion</div>
          <div className="ai-tagline">Intelligent Auditing</div>
        </div>

        {/* DNA Helix Animation */}
        <div className="ai-orb-wrapper">
          <div className="ai-particles">
            <span className="ai-particle" />
            <span className="ai-particle" />
            <span className="ai-particle" />
            <span className="ai-particle" />
            <span className="ai-particle" />
            <span className="ai-particle" />
          </div>
        </div>

        {/* Message with typewriter */}
        <div className="ai-message-wrapper">
          <div className="ai-message-line">
            <span className="ai-message-text">{displayedText}</span>
            <span className="ai-cursor" />
          </div>

          {/* Thinking dots */}
          <div className="ai-thinking">
            <span className="ai-thinking-dot" />
            <span className="ai-thinking-dot" />
            <span className="ai-thinking-dot" />
          </div>
        </div>

        {/* Audio waveform visualizer */}
        <div className="ai-waveform">
          <span className="ai-wave-bar" />
          <span className="ai-wave-bar" />
          <span className="ai-wave-bar" />
          <span className="ai-wave-bar" />
          <span className="ai-wave-bar" />
          <span className="ai-wave-bar" />
          <span className="ai-wave-bar" />
          <span className="ai-wave-bar" />
          <span className="ai-wave-bar" />
        </div>
      </div>
    </div>
  );
};

export default AILoadingScreen;
